import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <motion.footer
      className="bg-footer-bg text-white py-12"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.8 }}
    >
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="text-center md:text-left">
          <h3 className="text-xl font-bold mb-4 text-caterpillar-yellow">Contacto</h3>
          <p className="mb-2">Email: contacto@sedom.cl</p>
          <p className="mb-2">Teléfono: +56 9 7174 9915 / +56 9 4974 8604</p>
          <p>Dirección: Alcalde Pedro Alarcón 762, San Miguel - Santiago</p>
        </div>

        <div className="text-center">
          <h3 className="text-xl font-bold mb-4 text-caterpillar-yellow">Síguenos</h3>
          <div className="flex justify-center space-x-6">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition duration-300">
              <FaLinkedin size={30} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 transition duration-300">
              <FaInstagram size={30} />
            </a>
          </div>
        </div>

        <div className="text-center md:text-right">
          <h3 className="text-xl font-bold mb-4 text-caterpillar-yellow">SEDOM Empresa</h3>
          <p>&copy; {new Date().getFullYear()} Todos los derechos reservados.</p>
          <p>Construyendo el futuro, hoy.</p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;